export default __webpack_public_path__ + "static/noise-d095195e9883ee121289aa3ca61bbffd.png";